class CookieAPI {
  private static instance: CookieAPI;

  private constructor() {}

  static getInstance(): CookieAPI {
    if (!CookieAPI.instance) {
      CookieAPI.instance = new CookieAPI();
    }
    return CookieAPI.instance;
  }

  setCookie(name: string, value: string, days: number) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  setCookieObject(name: string, value: any, days: number) {
    let jsonString = JSON.stringify(value);
    let encodedJsonString = encodeURIComponent(jsonString);
    this.setCookie(name, encodedJsonString, days);
  }

  getCookieObject(name: string) {
    let storedCookieString = this.getCookie(name);
    if (!storedCookieString) {
      return null;
    }
    try {
      let decodedCookieValue = decodeURIComponent(storedCookieString);
      return JSON.parse(decodedCookieValue);
    } catch (error) {
      return {};
    }
  }

  getCookie(name: string) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) {
        let cookieValue = c.substring(nameEQ.length, c.length);
        return cookieValue;
      }
    }
    return null;
  }

  removeCookie(name: string) {
    this.setCookie(name, "", -1);
  }

  removeAllCookies() {
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      c = c.trim();
      let eqPos = c.indexOf("=");
      let name = eqPos > -1 ? c.substr(0, eqPos) : c;
      this.removeCookie(name);
    }
  }
}

const cookieAPI = CookieAPI.getInstance();
window.cookieAPI = CookieAPI.getInstance();
export default cookieAPI;
